import service from '../plugins/axiosConfig';
//客户注册
export function register(data) {
    return service({
        method: 'post',
        url: '/auth/clientRegister',
        data: data
    });
}
//获取小程序码
export function createSceneLogin(params) {
    return service({
        method: 'get',
        // url: '/system/wx/createSceneLogin',
        url: '/system/wx/getPPQRcode',
        params: params
    });
}
//获取邀请好友小程序码
export function inviteFriends(params) {
    return service({
        method: 'get',
        url: '/system/wx/inviteFriends',
        params: params
    });
}
//获取当前小程序码状态
export function getLoginStatus(params) {
    return service({
        method: 'get',
        url: '/system/wx/getLoginStatus',
        params: params
    });
}
//扫码登录后获取token
export function getWebLoginInfo(params) {
    return service({
        method: 'get',
        url: '/auth/getWebLoginInfo',
        params: params
    });
}

//客户修改
export function updateClient(data) {
    return service({
        method: 'put',
        url: '/system/client',
        data: data
    });
}

//客户详情
export function userInfo(id) {
    return service({
        method: 'get',
        url: '/system/client/' + id,
    });
}
// 登录后获取用户信息
export function getUSerInfo() {
    return service({
        method: 'get',
        url: '/system/client/getInfo',
    });
}
// 获取商城团队业务信息
export function getBizTeamInfo(clientId) {
    return service({
        method: 'get',
        url: '/reagentMall/portal/userInfo/getBizTeamInfo/' + clientId,
    });
}
//客户登录
export function login(data) {
    return service({
        method: 'post',
        url: '/auth/newloginorgister',
        data
    });
}
// 微信开放平台授权码快速登录
export function wxQuickLogin(data) {
    return service({
        method: 'post',
        url: '/auth/wxQuickLogin',
        data,
        headers: { isToken: false },
        suppressErrorMessage: true
    });
}
//客户退出登录
export function logout() {
    return service({
        method: 'Delete',
        url: '/auth/phoneLogout',
    });
}
//实名认证
export function realNameAuthentication(data) {
    return service({
        method: 'put',
        url: '/system/client/realNameAuthentication',
        data: data
    });
}
//更改手机号
export function updatePhone(params) {
    return service({
        method: 'get',
        url: '/system/client/updatePhone',
        params: params
    });
}
//验证码
export function sendCode(params) {
    return service({
        method: 'get',
        url: '/system/client/send',
        params: params
    });
}
// 设备列表
export function equipList(params) {
    return service({
        method: 'get',
        url: '/equipment/equipmentInfo/list',
        params: params,
    });
}
//热门设备列表
export function hotItemList(params) {
    return service({
        method: 'get',
        url: '/equipment/equipmentInfo/hotItemList',
        params: params,
    });
}
// 设备详情
export function equipInfo(id) {
    return service({
        method: 'get',
        url: '/equipment/equipmentInfo/' + id,
    });
}
//设备字段查询
export function equipmentSubscribeFieIdList(params) {
    return service({
        method: 'get',
        url: '/equipment/equipmentSubscribeFieId/listAll',
        params: params
    });
}
//再来一单
export function againOrder(subEquipmentId) {
    return service({
        method: 'get',
        url: `/equipment/order/againOrder/${subEquipmentId}`,
    });
}
//获取草稿箱详情---用于继续编辑草稿
export function subscribeDraftsInfo(draftId) {
    return service({
        method: 'get',
        url: `equipment/subscribeDrafts/${draftId}`,
    });
}

//发布需求
export function clientDemand(data) {
    return service({
        method: 'post',
        url: '/system/clientDemand',
        data: data
    });
}
//创建团队
export function creatTeam(data) {
    return service({
        method: 'post',
        url: '/system/team',
        data: data
    });
}
//编辑团队
export function editTeam(data) {
    return service({
        method: 'put',
        url: '/system/team',
        data: data
    });
}
//加入团队
export function teamList(params) {
    return service({
        method: 'get',
        url: '/system/team/list',
        params: params
    });
}
//移出团队
export function removeTeam(data) {
    return service({
        method: 'put',
        url: '/system/team/removeJoinTeam',
        data: data
    });
}
//转让团长
export function transferTeam(data) {
    return service({
        method: 'put',
        url: '/system/team/transferTeam',
        data: data
    });
}
//团队订单审核
export function checkTeamList(params) {
    return service({
        method: 'get',
        url: '/equipment/order/checkTeamList',
        params: params
    });
}
//设置管理员
export function setAdministrator(data) {
    return service({
        method: 'put',
        url: '/system/team/setAdministrator',
        data: data
    });
}

// 团队详情
export function teamInfo(id) {
    return service({
        method: 'get',
        url: '/system/team/' + id,
    });
}
//团队成员列表
export function joinTeamList(params) {
    return service({
        method: 'get',
        url: '/system/team/joinTeamList',
        params: params
    });
}
//入团申请审核
export function checkJoinTeam(data) {
    return service({
        method: 'put',
        url: '/system/team/checkJoinTeam',
        data: data
    });
}
//入团申请列表
export function joinTeamCheckList(params) {
    return service({
        method: 'get',
        url: '/system/team/joinTeamCheckList',
        params: params
    });
}
//申请加入
export function joinTeam(data) {
    return service({
        method: 'post',
        url: '/system/team/joinTeam',
        data: data
    });
}

//个人/团队优惠券列表
export function couponClient(params) {
    return service({
        method: 'get',
        url: '/coupon/couponClient/list',
        params: params
    });
}
//获取活动领取列表
export function activityList(params) {
    return service({
        method: 'get',
        url: '/coupon/couponClient/activityList',
        params: params
    });
}
//赠送金使用记录
export function couponRecordList(params) {
    return service({
        method: 'get',
        url: '/coupon/records/list',
        params: params
    });
}
//立即领取
export function drawCoupon(data) {
    return service({
        method: 'post',
        url: '/coupon/couponClient/drawCoupon',
        data: data
    });
}
// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return service({
        url: '/system/dict/data/type/' + dictType,
        method: 'get'
    })
}
//查询区域列表
export function unitList(params) {
    return service({
        url: '/system/unit/list',
        method: 'get',
        params: params
    })
}
//预约新增
export function equipmentSubscribeAdd(data) {
    return service({
        method: 'post',
        url: '/equipment/equipmentSubscribe/add',
        data: data
    });
}
//订单列表
export function memberOrderList(params) {
    return service({
        url: '/equipment/order/memberOrderList',
        method: 'get',
        params
    })
}
//订单详情
export function orderInfo(id) {
    return service({
        url: '/equipment/order/' + id,
        method: 'get'
    })
}
//订单取消
export function cancelOrder(data) {
    return service({
        url: '/equipment/order/cancelOrder',
        method: 'put',
        data
    })
}
// 商城我的订单列表
export function mallOrderList(params) {
    return service({
        url: '/reagentMall/portal/orderNew/main/myOrders/list',
        method: 'get',
        params
    })
}
//商城可开票订单列表
export function mallInvoiceAvailableOrderList(params) {
    return service({
        url: '/reagentMall/portal/order/invoice/available-orders',
        method: 'get',
        params
    })
}
// 商城预存可选 SKU
export function reagentMallPrestoreSkuOptions(params) {
    return service({
        url: '/reagentMall/finance/invoice/prestore/sku-options',
        method: 'get',
        params
    })
}
// 商城财务申请（预存/订单开票）
export function applyReagentMallFinance(data) {
    return service({
        url: '/reagentMall/finance/invoice/apply',
        method: 'post',
        data
    })
}
//商城用户发票列表
export function mallInvoiceList(params) {
    return service({
        url: '/reagentMall/finance/invoice/list',
        method: 'get',
        params
    })
}
// 商城团队发票列表
export function teamMallInvoiceList(rmTeamId, params) {
    return service({
        url: `/reagentMall/finance/invoice/team-list/${rmTeamId}`,
        method: 'get',
        params
    })
}
//商城用户发票详情
export function mallInvoiceInfo(invoiceId) {
    return service({
        url: `/reagentMall/finance/invoice/${invoiceId}`,
        method: 'get'
    })
}
// 商城团队发票详情
export function teamMallInvoiceInfo(rmTeamId, invoiceId) {
    return service({
        url: `/reagentMall/finance/invoice/team-detail/${rmTeamId}/${invoiceId}`,
        method: 'get'
    })
}
// 商城我的订单状态统计
export function mallOrderStatusCount(params) {
    return service({
        url: '/reagentMall/portal/orderNew/main/myOrders/statusCount',
        method: 'get',
        params
    })
}
// 商城订单详情
export function mallOrderInfo(params) {
    return service({
        url: '/reagentMall/portal/orderNew/main/orderDetail',
        method: 'get',
        params
    })
}
// 商城订单取消
export function cancelMallOrder(data) {
    return service({
        url: '/reagentMall/portal/orderNew/main/cancel',
        method: 'post',
        data
    })
}
// 商城订单确认收货
export function confirmMallOrder(data) {
    return service({
        url: '/reagentMall/portal/orderNew/main/confirm',
        method: 'post',
        data
    })
}
// 商城团队订单列表
export function teamMallOrderList(params) {
    return service({
        url: '/reagentMall/portal/orderNew/main/teamOrders/list',
        method: 'get',
        params
    })
}
// 商城团队订单状态统计
export function teamMallOrderStatusCount(params) {
    return service({
        url: '/reagentMall/portal/orderNew/main/teamOrders/statusCount',
        method: 'get',
        params
    })
}
// 商城团队订单审核通过
export function approveTeamMallOrder(data) {
    return service({
        url: '/reagentMall/portal/orderNew/main/teamOrders/approve',
        method: 'post',
        data
    })
}
// 商城团队订单审核拒绝
export function rejectTeamMallOrder(data) {
    return service({
        url: '/reagentMall/portal/orderNew/main/teamOrders/reject',
        method: 'post',
        data
    })
}
//商城订单支付状态查询
export function mallPaymentStatus(paymentNo) {
    return service({
        url: `/reagentMall/portal/order/payment/${paymentNo}/status`,
        method: 'get'
    })
}
//商城订单申请开票
export function submitMallOrderInvoice(data) {
    return service({
        url: '/reagentMall/portal/order/invoice/apply',
        method: 'post',
        data
    })
}
//价格疑异
export function clientSubmitAfterSafes(data) {
    return service({
        url: '/equipment/order/clientSubmitAfterSafes',
        method: 'post',
        data
    })
}
//查看订单发票
export function getOrderInvoiceInfo(params) {
    return service({
        url: '/equipment/invoiceInformation/getOrderInvoiceInfo',
        method: 'get',
        params
    })
}
// 客服二维码
export function customerServiceQrcode() {
    return service({
        url: '/system/dict/data/type/customer_service_qrcode',
        method: 'get',
    })
}
//上传包裹
export function uploadPackage(data) {
    return service({
        url: '/equipment/order/uploadPackage',
        method: 'put',
        data: data
    })
}
//评价
export function orderEvaluation(data) {
    return service({
        url: '/equipment/order/orderEvaluation',
        method: 'put',
        data: data
    })
}
//确认结果
export function finishOrder(data) {
    return service({
        url: '/equipment/order/finishOrder',
        method: 'put',
        data: data
    })
}
//查询检测信息
export function getDetectionDetail(id) {
    return service({
        url: '/equipment/order/detectionInfo/' + id,
        method: 'get'
    })
}
//查询(月)设备预约记录
export function getAppointmentRecord(query) {
    return service({
        url: '/equipment/equipmentInfo/getAppointmentRecord',
        method: 'get',
        params: query
    })
}
//设备预约是否有冲突
export function appointmentConflict(query) {
    return service({
        url: '/equipment/equipmentInfo/appointmentConflict',
        method: 'get',
        params: query
    })
}
//团队订单
export function teamOrderList(params) {
    return service({
        url: '/equipment/order/teamOrderList',
        method: 'get',
        params
    })
}
//团队订单列表---用于【帮ta还款】
export function helpRepaymentList(params) {
    return service({
        url: '/equipment/order/helpTeamMemberRepayment',
        method: 'get',
        params
    })
}

//团队订单操作---【帮ta还款】
export function helpRepayment(data) {
    return service({
        url: '/system/team/financialCenter/helpTeamMemberRepayment',
        method: 'post',
        data
    })
}
//根据客户id查询订单
export function clientOrderList(query) {
    return service({
        url: '/equipment/order/clientOrderList',
        method: 'get',
        params: query
    })
}
//订单删除
export function delOrder(id) {
    return service({
        url: '/equipment/order/' + id,
        method: 'delete'
    })
}
//文件下载
export function fileZipDownload(query) {
    return service({
        url: '/file/communal/download/fileZipDownload',
        method: 'get',
        params: query
    })
}
//开票信息详情
export function invoiceHeadInfo(id) {
    return service({
        url: '/equipment/invoiceHead/' + id,
        method: 'get'
    })
}
//开票信息编辑
export function saveInvoiceHead(data) {
    return service({
        url: '/equipment/invoiceHead/saveInvoiceHead',
        method: 'post',
        data: data
    })
}
//业务员列表
export function salesmanList(params) {
    return service({
        url: '/system/dict/data/type/salesman_name',
        method: 'get',
        params
    })
}
//申请开票
export function postInvoice(data) {
    return service({
        url: '/equipment/invoiceInformation/applyInvoice',
        method: 'post',
        data
    })
}
//实验结果发送邮箱
export function EMailSend(params) {
    return service({
        url: '/equipment/uploadCenter/qqMailSend',
        method: 'post',
        params
    })
}
//获取申请确认订单
export function requestOrderList(query) {
    return service({
        url: '/equipment/order/clientOwnInvoiceList',
        method: 'get',
        params: query
    })
}
//我的发票
export function invoiceList(query) {
    return service({
        url: '/equipment/invoiceInformation/list',
        method: 'get',
        params: query
    })
}

//发票删除
export function invoiceDel(id) {
    return service({
        url: '/equipment/invoiceInformation/' + id,
        method: 'delete',
    })
}
//发票详情
export function invoiceInfo(id) {
    return service({
        url: '/equipment/invoiceInformation/' + id,
        method: 'get'
    })
}
//检测项目下拉
export function testItemList(query) {
    return service({
        url: '/equipment/equipmentDetectionItem/listAll',
        method: 'get',
        params: query
    })
}
//上传凭证
export function uploadPaymentVoucher(data) {
    return service({
        url: '/equipment/invoiceInformation/uploadPaymentVoucher',
        method: 'put',
        data: data
    })
}
//个人预存记录
export function prestoreRecord(query) {
    return service({
        url: '/equipment/prestoreRecord/personalList',
        method: 'get',
        params: query
    })
}
//团队预存记录
export function teamPrestoreRecord(query) {
    return service({
        url: '/equipment/prestoreRecord/teamList',
        method: 'get',
        params: query
    })
}
//预存划拨
export function prestoreTransfer(query) {
    return service({
        url: '/equipment/prestoreTransfer/transfer',
        method: 'post',
        data: query
    })
}
//预存划拨列表
export function prestoreTransferList(query) {
    return service({
        url: '/equipment/prestoreTransfer/list',
        method: 'get',
        params: query
    })
}
//发票下载
export function getInvoiceFile(id) {
    return service({
        url: '/equipment/invoiceInformation/getInvoiceFile/' + id,
        method: 'get'
    })
}

// 查询团队空间
export function spaceTeamList(params) {
    return service({
        url: '/fileSpace/fileShared/spaceTeamList',
        method: 'get',
        params: params
    })
}
// 查询文件列表
export function myFileList(params) {
    return service({
        url: '/fileSpace/fileShared/spaceFile/list',
        method: 'get',
        params: params
    })
}
//邀请好友记录
export function inviteList(params) {
    return service({
        url: '/system/invite/list',
        method: 'get',
        params: params
    })
}
//团队邀请好友二维码
export function inviteTeamFriends(params) {
    return service({
        url: '/system/wx/inviteTeamFriends',
        method: 'get',
        params: params
    })
}
//我的资产相关金额
export function myAssetsMoney(id) {
    return service({
        method: 'get',
        url: '/system/client/myAssets/' + id,
    });
}
//对账单查询接口
export function statementAccountList(params) {
    return service({
        url: '/equipment/order/statementAccountList',
        method: 'get',
        params: params
    })
}
//下载对账单
export function invoiceResultExport(params) {
    return service({
        url: '/equipment/order/exportStandingBook',
        method: 'get',
        params: params
    })
}
//省市-学院接口
export function schoolList(params) {
    return service({
        url: 'system/school/list',
        method: 'get',
        params: params
    })
}
//订单审核
export function orderCheck(data) {
    return service({
        url: '/equipment/order/orderCheck',
        method: 'put',
        data
    })
}
//记录首次下载实验数据
export function dataDownload(params) {
    return service({
        url: '/equipment/order/dataDownload',
        method: 'get',
        params: params
    })
}
//其他需求新增
export function saveUpdate(data) {
    return service({
        url: '/equipment/otherDemand/saveUpdate',
        method: 'post',
        data: data
    })
}
//首页轮播图
export function carouselList(params) {
    return service({
        url: '/system/carousel/list',
        params: params
    })
}

// 订单支付状态查询---用预约id
export function checkPayStatus(id) {
    return service({
        url: '/equipment/order/sub/' + id,
        method: 'get',
    })
}

//pc端生成微信支付二维码
export function createWXOrder(data) {
    return service({
        url: '/equipment/weChatNativePay/createOrder',
        method: 'post',
        data: data
    })
}
//pc端生成微信支付二维码---用于【订单操作】的【立即还款】
export function WxRepayment(data) {
    return service({
        url: '/equipment/weChatNativePay/createRepayment',
        method: 'post',
        data: data
    })
}

//微信根据订单号查询订单支付状态
export function queryOrderByOutTradeNo(params) {
    return service({
        url: '/equipment/weChatNativePay/queryOrderByCode',
        method: 'get',
        params: params
    })
}
//支付宝支付下单
export function ZFBPreorderAction(data) {
    return service({
        url: '/equipment/alipay/prePay',
        method: 'post',
        data: data
    })
}

//支付宝支付订单查询
export function queryAliOrderByOutTradeNo(params) {
    return service({
        url: '/equipment/alipay/queryOrderByOutTradeNo',
        method: 'get',
        params: params
    })
}

//微信根据预约id关闭订单
export function closeByWxOutTradeNo(params) {
    return service({
        url: '/equipment/weChatNativePay/closeByOutTradeNo',
        method: 'get',
        params: params
    })
}

// 微信支付（补差价）
export function makeUpMoneyWx(data) {
    return service({
        url: '/equipment/weChatNativePay/makeUpMoneyPC',
        method: 'post',
        data: data
    })
}
// 支付宝支付（补差价）
export function makeUpMoneyAli(data) {
    return service({
        url: '/equipment/alipay/makeUpMoney',
        method: 'post',
        data: data
    })
}
// 微信根据单号查询订单支付状态（补差价）

// 确认结果补钱之后更新订单状态（补差价支付后调用）
export function editOrderMoney(data) {
    return service({
        url: '/equipment/order/editOrderMoney',
        method: 'put',
        data: data
    })
}

//查询字段组详情
export function getEquipmentFieldGroupList(id) {
    return service({
        url: '/equipment/fieldGroup/' + id,
        method: 'get'
    })
}
//积分商城列表
export function pointsMallList(query) {
    return service({
        url: '/coupon/pointsMall/list',
        method: 'get',
        params: query
    })
}
//兑换记录
export function pointsRecordList(query) {
    return service({
        url: '/coupon/pointsRecord/list',
        method: 'get',
        params: query
    })
}
//兑换商品
export function exchangePoints(data) {
    return service({
        url: '/coupon/pointsRecord/exchangePoints',
        method: 'post',
        data: data
    })
}
//积分规则查询
export function pointsRuleList(query) {
    return service({
        url: '/coupon/pointsRule/ruleList',
        method: 'get',
        params: query
    })
}
//文件合并
export function merageFile(params) {
    return service({
        url: '/file/merageFile',
        method: 'get',
        params: params
    })
}
//新增合作商
export function saveProducer(data) {
    return service({
        url: '/equipment/producer/save',
        method: 'post',
        data: data
    })
}
//财务开票
// /equipment/financeInvoice/makeInvoice 、
export function makeInvoice(data) {
    return service({
        url: '/equipment/financeInvoice/makeInvoice',
        method: 'post',
        data: data
    })
}
//发票详情
// equipment/financeInvoice/getInvoiceInfoStatus/
export function getInvoiceInfoStatus(id) {
    return service({
        url: '/equipment/financeInvoice/getInvoiceInfoStatus/' + id,
        method: 'get'
    })
}

//获取申请开票检测列表
export function getCheckItemList(params) {
    return service({
        url: '/equipment/invoiceInformation/checkItemList',
        method: 'get',
        params: params
    })
}

//区域列表
export function getUnitList(params) {
    return service({
        url: '/system/unit/list',
        method: 'get',
        params: params
    })
}
//白名单
// 客户白名单列表
export function listClientWhiteList(query) {
    return service({
        url: '/system/clientWhiteList/list',
        method: 'get',
        params: query
    })
}
//查询抬头列表
export function listInvoiceHead(params) {
    return service({
        url: '/equipment/invoiceHead/list',
        method: 'get',
        params
    })
}
//设置默认抬头
export function setDefault(data) {
    return service({
        url: '/equipment/invoiceHead/setDefault',
        method: 'post',
        data: data
    })
}
//删除抬头
export function deleteInvoiceHead(id) {
    return service({
        url: '/equipment/invoiceHead/' + id,
        method: 'delete'
    })
}
//解散团队
export function dissolveTeam() {
    return service({
        method: 'post',
        url: '/system/team/dissolveTeam'
    });
}

//查询开票日志
export function getInvoiceApplyLogList(id) {
    return service({
        url: '/equipment/invoiceApplyLog/list/' + id,
        method: 'get'
    })
}
//查询团队财务信息
export function getFinancialCenterInfo(id) {
    return service({
        url: '/system/team/financialCenter/findTeamInfo/' + id,
        method: 'get'
    })
}
//查询团队流水
export function getFinancialCenterLogList(query) {
    return service({
        url: '/equipment/financialCenterLog/logList',
        method: 'get',
        params: query
    })
}

//查询团队/个人待还款订单(type:1 团队 2 个人, relateId:客户id/团队id)
// /team/financialCenter/findNeedRepaymentOrder
export function findNeedRepaymentOrder(query) {
    return service({
        url: '/equipment/order/findNeedRepaymentOrder',
        method: 'get',
        params: query
    })
}

// 个人/团队还款
export function orderRepayment(data) {
    return service({
        method: 'post',
        url: '/system/team/financialCenter/repayment',
        data: data
    });
}

//查询用户其他信息
export function getUserOtherInfo(id) {
    return service({
        url: '/system/clientInfo/' + id,
        method: 'get'
    })
}

//客户认证
export function clientCertApply(data) {
    return service({
        url: '/system/clientCertApply',
        method: 'post',
        data: data
    })
}
//获取客户认证记录
export function getClientCertApply(id) {
    return service({
        url: '/system/clientCertApply/' + id,
        method: 'get'
    })
}
//文件合并
export function blockUploadSuccess(params) {
    return service({
        url: '/file/blockUploadSuccess',
        method: 'get',
        params: params
    })
}

//获取文件夹UUID
export function getFileUUID() {
    return service({
        url: '/file/uuid',
        method: 'get'
    })
}
//发票抬头列表
export function getInvoiceHeadContrastList(query) {
    return service({
        url: '/equipment/invoiceHeadContrast/list',
        method: 'get',
        params: query
    })
}

//获取七牛云下载链接
export function getDownLoadUrl(query) {
    return service({
        url: '/equipment/uploadCenter/getDownLoadUrl',
        method: 'get',
        params: query
    })
}

//转存验证码
export function sendPrestoreVerifyCode(query) {
    return service({
        url: '/system/client/sendPrestoreVerifyCode',
        method: 'get',
        params: query
    })
}
//预存转存
export function clientCeconvertToTeamPrestorertApply(data) {
    return service({
        url: '/system/client/convertToTeamPrestore',
        method: 'post',
        data: data
    })
}
//团员支付开启审核开关
export function controlTeamAuditFlag(data) {
    return service({
        url: '/system/client/controlTeamAuditFlag',
        method: 'post',
        data: data
    })
}
//团队开票订单
export function getTeamOrderInvoiceList(query) {
    return service({
        url: '/equipment/order/teamOrderInvoiceList',
        method: 'get',
        params: query
    })
}
//设置密码
export function setPwdOrEdit(data) {
    return service({
        url: '/system/client/setPwdOrEdit',
        method: 'post',
        data: data
    })
}
//发送密码验证码
export function sendPwdCode(query) {
    return service({
        url: '/system/client/sendPwdCode',
        method: 'get',
        params: query
    })
}
//获取图形验证码
export function getCodeImg() {
    return service({
        url: '/code',
        headers: {
            isToken: false
        },
        method: 'get'
    })
}
//找回密码
export function findPassword(data) {
    return service({
        url: '/system/client/findPassword',
        method: 'post',
        data: data
    })
}
//获取主页活动弹窗图片
export function getActives(categoryId) {
    return service({
        url: `/coupon/activity/config/category/${categoryId}`
    })
}
// 团购活动------获取团购活动列表
export function getTeamShopList(activityId) {
    return service({
        url: `/coupon/activity/config/activityEquipmentsList/${activityId}`
    })
}
//团购活动------查询团购活动下的设备详情
export function getTeamShopDetail(activityEquipmentId) {
    return service({
        url: `/coupon/activity/config/activityEquipmentDetail/${activityEquipmentId}`
    })
}
//下单返现活动------获取下单返现活动信息
export function getCashBackDetail() {
    return service({
        url:'/coupon/activity/transfer/getTransferAccountDetail'
    })
}
//幸运转盘活动------获取活动信息
export function getWheelDetail(id) {
    return service({
        url: `/coupon/wheel/getWheelDetail/${id}`
    })
}
//下单转盘活动------获取活动信息
export function getOrderWheelDetail(id) {
    return service({
        url: `/coupon/activity/placeOrderWheel/wheelDetail/${id}`
    })
}
//获取跳转至小程序活动页面的二维码
export function getQRcode(path,width,scene) {
    return service({
        url:'/system/wx/getOpenQRCode',
        params: {
            page: path,
            width,
            scene
        }
    })
}
// 邀请好友首页接口
export function getInviteFriends() {
    return service({
        url: '/coupon/activity/commission/board'
    })
}
// 邀请人数列表页
export function getInviteFriendsList(query) {
    return service({
        url: '/system/invite/clientList',
        params: query
    })
}
// 预估收益列表页
export function getEstimateIncomeList(query) {
    return service({
        url: '/coupon/activity/commission/orderRelateList',
        params: query
    })
}
//下载海报
export function downloadPoster(query) {
    return service({
        url: '/system/wx/inviteFriendsPoster',
        method: 'get',
        params: query
    })
}
//预存限制
export function editPrestoreControl(params) {
    return service({
        url: '/system/team/editPrestoreControl',
        method: 'post',
        params
    })
}
//草稿箱列表
export function subscribeDraftsList(params) {
    return service({
        url: '/equipment/subscribeDrafts/list',
        method: 'get',
        params
    })
}
//添加至草稿箱
export function addSubscribeDrafts(data) {
    return service({
        url: '/equipment/subscribeDrafts',
        method: 'post',
        data
    })
}
//删除草稿
export function deleteSubscribeDrafts(id) {
    return service({
        url: `/equipment/subscribeDrafts/${id}`,
        method: 'delete',
    })
}


// 查询积分商城发放记录列表
export function getPointsRecordClientList(query) {
    return service({
        url: '/coupon/pointsRecord/client/list',
        method: 'get',
        params: query
    })
}
// 查询积分商城我的礼品列表
export function getPointsExchangeClientList(query) {
    return service({
        url: '/coupon/pointExchange/client/list',
        method: 'get',
        params: query
    })
}
// 积分商城兑换商品
export function exchangePointsClient(data) {
    return service({
        url: '/coupon/pointExchange/exchange',
        method: 'post',
        data: data
    })
}
// 积分商城填写信息
export function savePointsExchangeWriteInfo(data) {
    return service({
        url: '/coupon/pointExchange/writeInfo',
        method: 'post',
        data: data
    })
}
// 查看兑换信息接口
export function getPointsExchangeInfo(id) {
    return service({
        url: `/coupon/pointExchange/${id}`,
        method: 'get'
    })
}
// 获取七牛Token（活动数据）
export function getActivityUploadGetToken(query) {
  return service({
    url: '/equipment/uploadCenter/getActivityUploadGetToken',
    method: 'get',
    params: query
  })
}
//【投诉/建议】 提交
export function useSubmitFeedback(data) {
    return service({
        url: `/system/feedback/add`,
        method: 'post',
        data
    })
}
//仪器采购---列表
export function useGetEquipmentMall(params) {
    return service({
        url: 'equipment/equipmentmall',
        method: 'get',
        params,
    })
}
